import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import BaseService from './base-service';
import { API_BASE_URL } from '@/constants';

export default async function sendRequest<Response = unknown, Request = Record<string, unknown>>(
  params: AxiosRequestConfig<Request>
) {
  return new Promise<Response>((resolve, reject) => {
    BaseService({ ...params, baseURL: params.baseURL || API_BASE_URL })
      .then((response: AxiosResponse<Response>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}
